import { Droits } from './droits.model';

/**
 * Définition abstraite d'un utilisateur.
 */
export abstract class Utilisateur {
	login: string | undefined;
	firstName: string | undefined;
	lastName: string | undefined;
	roles: string[] | undefined;
	droits: Droits | undefined;
	langue: string | undefined;

	/**
	 * Initialise la liste de l'ensemble des droits possibles pour un utilisateur.
	 * Ces droits dépendent de chaque application.
	 */
	abstract initialiserDroits(): void;
}
